import type { CSSProperties } from 'react'
import { tokens } from '@/theme'

/**
 * The input and button styles every screen shares. A plain module rather than
 * part of controls.tsx, because fast refresh wants component files to export
 * only components.
 */

export const inputStyle: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '9px 11px',
  fontFamily: tokens.fontBody,
  fontSize: tokens.sizeBody,
  lineHeight: 1.55,
  color: tokens.ink,
  background: tokens.paper,
  border: `1px solid ${tokens.line2}`,
  borderRadius: tokens.radiusSm,
}

const buttonBase: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  borderRadius: tokens.radiusMd,
  fontFamily: tokens.fontDisplay,
  fontSize: 11,
  fontWeight: tokens.weightDemi,
  letterSpacing: '0.11em',
  textTransform: 'uppercase',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
}

export const primaryButton: CSSProperties = {
  ...buttonBase,
  background: tokens.gold,
  color: tokens.paper,
  border: 'none',
  padding: '9px 16px',
}

export const secondaryButton: CSSProperties = {
  ...buttonBase,
  background: 'transparent',
  color: tokens.ink2,
  border: `1px solid ${tokens.line2}`,
  padding: '8px 14px',
}

/**
 * Spread after a button style on a phone: a 44px touch target, the platform
 * minimum. PersonView and the account sheet used 48 before this was shared.
 */
export const mobileButton: CSSProperties = {
  minHeight: 44,
  padding: '0 14px',
  fontSize: 12,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
}

export const fieldLabel: CSSProperties = {
  fontSize: 11,
  fontWeight: tokens.weightDemi,
  letterSpacing: '0.12em',
  textTransform: 'uppercase',
  color: tokens.ink3,
}

export const linkButton: CSSProperties = {
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: tokens.fontDisplay,
  fontWeight: tokens.weightDemi,
  color: tokens.ink,
  textAlign: 'left',
}
